export type LogMessage = (message?: any, ...optionalParams: any[]) => void;

export interface Logger {
  debug: LogMessage;
  info: LogMessage;
  warn: LogMessage;
  error: LogMessage;
}

const NO_OP: LogMessage = () => {};

export class ConsoleLogger implements Logger {
  readonly debug: LogMessage = NO_OP;
  readonly info: LogMessage = NO_OP;
  readonly warn: LogMessage = NO_OP;
  readonly error: LogMessage = console.error.bind(console);
}

export const logger: Logger = new ConsoleLogger();
